import { SAVE_LOCAL_CLIENT_TAGS } from './saveLocalTags.types';

const saveLocalTags = (clientTagList) => ({
  type: SAVE_LOCAL_CLIENT_TAGS,
  clientTagList,
});

export default saveLocalTags;
